module.exports = __webpack_public_path__ + "img/01.f7895a69.png";